export default {
  authenticated: false,
  shop: null,
  shopToken: null, // jwt
};
